__turbopack_context__.v({
  "dropdown": "SearchDropdown-module-scss-module__jwmFOa__dropdown",
  "group": "SearchDropdown-module-scss-module__jwmFOa__group",
  "groupHeader": "SearchDropdown-module-scss-module__jwmFOa__groupHeader",
  "groupTitle": "SearchDropdown-module-scss-module__jwmFOa__groupTitle",
  "groups": "SearchDropdown-module-scss-module__jwmFOa__groups",
  "item": "SearchDropdown-module-scss-module__jwmFOa__item",
  "itemName": "SearchDropdown-module-scss-module__jwmFOa__itemName",
  "items": "SearchDropdown-module-scss-module__jwmFOa__items",
  "loading": "SearchDropdown-module-scss-module__jwmFOa__loading",
  "loadingText": "SearchDropdown-module-scss-module__jwmFOa__loadingText",
  "noResults": "SearchDropdown-module-scss-module__jwmFOa__noResults",
  "noResultsText": "SearchDropdown-module-scss-module__jwmFOa__noResultsText",
});
